module.exports = __webpack_public_path__ + "img/mind_skeleton_29.3018e485.png";